import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import InspectionItem from '../InspectionItem'
import { renderFullDate } from '../../../../utils/time'
import { translation } from '../../../../utils/helpers'
import UserInfo from '../../../../shared/components/UserInfo'
// Constants

// Modals
import StopLockOrderModal from '../../../../shared/modals/StopLockOrderModal'
// Actions
import { triggerPopup } from '../../../../actions/backdrop'
import { GetNewDeliveryForResume, StopLockOrder, getOrder } from '../../../../actions/orders'

// Elements
import Button from '../../../../shared/elements/button'
import LabelWrapper from '../../../../shared/elements/labelWrapper'

class OrderStop extends Component {

  constructor (props) {
    super(props)
    this.state = {
      id: 0,
      stopMessage: '',
      stoplockorder: {
        open: false,
        id: 0
      },
      order: this.props.order
    }
    this.renderContent = this.renderContent.bind(this)
    this.handleClick = this.handleClick.bind(this)
  }

  componentDidMount () {
  }

  renderContent () {
    const renderOldComment = () => {
      let commentHeader = (
        <span>
          <UserInfo user={this.state.order.OrderStop.StoppedByUserInfo} />
          {renderFullDate(this.state.order.OrderStop.StoppedDate)}
        </span>
      )
      return (
        <LabelWrapper labelText={commentHeader}>
          {this.state.order.OrderStop.StoppedMessage}
        </LabelWrapper>
      )
    }
    let btnText = translation('2218')
    if (this.state.order.IsStopped) {
      btnText = translation('2220')
    }
    // console.log('ITEM ---------->', this.state.order)
    return (
      <div>
        {this.state.order.IsStopped && (renderOldComment())}
        <Button onClick={this.handleClick} labelText={btnText} style='link' />
        {/* <img src='/images/svgs/inspection/stop-hand-white.svg' /> */}
      </div>
    )
  }
  handleClick (e) {
    if (this.state.order.IsStopped) {
      this.props.GetNewDeliveryForResume(this.props.order.Id).then(res => {
        if (res.data !== null) {
          this.setState({
            newDelivery: res.data.NewDeliveryDateTime,
            isMoreThanHalfAnHour: res.data.IsMoreThanHalfAnHour,
            isStopped: res.data.IsStopped
          }, () => {
            // if (this.state.isStopped && !this.state.isMoreThanHalfAnHour) {
            //   this.stopLockResumeWithoutPopUp()
            // } else {
            this.props.triggerPopup(!this.state.stoplockorder.open)
            this.setState({
              stoplockorder: {
                open: !this.state.stoplockorder.open,
                id: this.state.order.Id
              }
            })
            // }
          })
        }
      })
    } else {
      this.props.triggerPopup(!this.state.stoplockorder.open)
      this.setState({
        stoplockorder: {
          open: !this.state.stoplockorder.open,
          id: this.state.order.Id
        }
      })
    }
  }
  onPortalClose (type) {
    this.props.getOrder(this.props.order.Id).then((res) => {
      this.setState({
        order: res.data
      })
    })
    this.setState({
      [type]: {
        ...this.state[type],
        open: false
      }
    })
    this.props.triggerPopup(false)
  }

  stopLockResumeWithoutPopUp () {
    let data = {
      ApplyToInvoice: this.state.order.OrderStop.StoppedMessageApplyToInvoice,
      ShowCustomer: this.state.order.OrderStop.StoppedMessageShowCustomer,
      Message: this.state.order.OrderStop.StoppedMessage,
      OrderId: this.props.order.Id,
      TimeAction: 2 // keep old time
    }
    this.props.StopLockOrder(data).then((res) => {
      // window.toastr.success(translation('13403'), translation('13424'))
      this.onPortalClose('stoplockorder')
      // this.getNewOrder()    // This doesn't exist (??)
    }, () => {
      window.toastr.error(translation('13404'), translation('216'))
    })
  }

  renderPopup () {
    return (
      <div className='order__action'>
        {this.state.stoplockorder.open && (
          <StopLockOrderModal
            show={this.state.stoplockorder.open}
            item={this.state.order}
            id={this.state.stoplockorder.id}
            newDelivery={this.state.newDelivery}
            onClose={this.onPortalClose.bind(this, 'stoplockorder')} />
        )}
      </div>
    )
  }
  render () {
    let title = { icon: '/images/svgs/inspection/stop-hand.svg', text: '2218' }
    return (
      <div key='box_2'>
        <InspectionItem title={title} renderContent={this.renderContent} showCheckmark={false} />
        {this.renderPopup()}
      </div>
    )
  }
}

OrderStop.defaultProps = {
  isBodyshop: false
}

OrderStop.propTypes = {
  stopLockOrder: PropTypes.func.isRequired,
  isBodyshop: PropTypes.bool,
  order: PropTypes.object.isRequired
}

OrderStop.contextTypes = {
  router: PropTypes.object.isRequired
  // t: React.PropTypes.func.isRequired,
  // enum: React.PropTypes.func.isRequired
}
function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
  StopLockOrder,
  StopLockOrderModal,
  triggerPopup,
  GetNewDeliveryForResume,
  getOrder
})(OrderStop)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderInspection/OrderStop/index.js